module.exports = __webpack_public_path__ + "img/expenses.133a9bbc.svg";